export default __webpack_public_path__ + "static/media/icon_info_dialog_red.c5cd82bd.svg";